import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';

import useStyles from './styles';

function SplashScreen() {
  const classes = useStyles();

  return (
    <div className={classes.loadingPage}>
      <Box display="flex" justifyContent="center" mb={6}>
        <img className={classes.logo} src="/img/logos/logo_color.svg" alt="logo" />
      </Box>
      <CircularProgress style={{ color: 'var(--brand-blue' }} />
    </div>
  );
}

export default SplashScreen;
